import { useMemo } from 'react'
import { format } from 'date-fns'
import { useGetUserProfile } from 'Features/userProfile/api/getUserProfile'
import DateFormats from 'Assets/lists/dateFormats'
import { utcToZonedTime } from 'date-fns-tz'

export const useLocalizedDate = () => {
  const userSettings = useGetUserProfile()
  const locale = useMemo(() => {
    if (!(userSettings.data instanceof Error)) {
      return userSettings?.data?.locale
    } else {
      return DateFormats[0].value
    }
  }, [userSettings.data])
  const getLocalizedDate = (date: Date, includeHour?: boolean) => {
    let zonedDate = date
    zonedDate = utcToZonedTime(date, userSettings?.data?.timezoneCountry || 'UTC')

    const formatOptionsUs = includeHour ? 'MM/dd/yy hh:mm a' : 'MM/dd/yy'
    const formatOptionsNonUs = includeHour ? 'dd/MM/yy HH:mm:ss' : 'dd/MM/yy'

    if (locale === DateFormats[1].value) {
      // en-US
      return format(zonedDate, formatOptionsUs)
    } else if (locale === DateFormats[0].value) {
      // en-UK
      return format(zonedDate, formatOptionsNonUs)
    } else {
      // fallback - take user's browser locale format
      return new Intl.DateTimeFormat(navigator.language).format(zonedDate)
    }
  }

  return { getLocalizedDate }
}
